<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
      <el-tab-pane label="查询" v-if="isAdmin||isAgent" name="userInfo">
        <div class="handle-box">
          <el-input size="small" v-model="phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                     @click="dxtQuerys">搜索
          </el-button>
        </div>
        <div v-if="dxtDet.BILL_ID" class="region_box">
          <div class="region_list">
            <div class="region_list_tit">激活地址：</div>
            <div class="region_list_info">{{ dxtDet.ACTIVE_REGION }}</div>
          </div>
          <div class="region_list">
            <div class="region_list_tit">首通地址：</div>
            <div class="region_list_info">{{ dxtDet.FIRST_REGION }}</div>
          </div>
          <div class="region_list">
            <div class="region_list_tit">漫游地址：</div>
            <div class="region_list_info">{{ dxtDet.ROAM_REGION }}</div>
          </div>
        </div>
        <div class="table-box" v-if="dxtDet.BILL_ID">
          <div class="user-info-box" style="width: 300px;">
            <div class="user-info-tit">账户信息</div>
            <div class="info-box">
              <div class="info-name">号码：</div>
              <div class="info">{{ dxtDet.BILL_ID }}</div>
            </div>
            <div class="info-box">
              <div class="info-name">地市：</div>
              <div class="info">{{ dxtDet.DISTRICT_NAME }}</div>
            </div>
            <div class="info-box">
              <div class="info-name">网络：</div>
              <div class="info">{{ dxtDet.NET }}</div>
            </div>
            <div class="info-box">
              <div class="info-name">限频：</div>
              <div class="info">{{ dxtDet.VOICE_MONITOR_NUMBER || 0 }}</div>
            </div>
          </div>
          <div class="user-info-box">
            <div class="user-info-tit">账户状态</div>
            <div class="info-box">
              <div class="info-name">用户状态：</div>
              <div class="info">{{ dxtDet.STATE }}
                <span v-if="dxtDet.QT_CAUSE">（{{ dxtDet.QT_CAUSE }}）</span>
              </div>
            </div>
            <div class="info-box">
              <div class="info-name">套餐名称：</div>
              <div class="info">{{ dxtDet.ORDER_NAME }}</div>
            </div>
            <div class="info-box">
              <div class="info-name">激活时间：</div>
              <div class="info">{{ dxtDet.ACTIVE_DATE }}</div>
            </div>
            <div class="info-box">
              <div class="info-name"></div>
              <div class="info"></div>
            </div>
          </div>
          <div class="user-info-box" style="width: 300px;">
            <div class="user-info-tit">话费余量</div>
            <div class="info-box">
              <div class="info-name">当月消费：</div>
              <div class="info">{{ dxtDet.BALANCE }}元</div>
            </div>
            <div class="info-box">
              <div class="info-name">欠费金额：</div>
              <div class="info" style="color: #E81A1A;">{{ dxtDet.AMOUNT_OWED }}元</div>
            </div>
            <div class="info-box">
              <div class="info-name">话费余额：</div>
              <div class="info" style="color: #B12E2E;">{{ dxtDet.REAL_BALANCE }}元</div>
            </div>
            <div class="info-box">
              <div class="info-name"></div>
              <div class="info"></div>
            </div>
          </div>

        </div>
        <div class="table-box" v-if="dosageVO">
          <div class="user-info-box" style="width: 300px;">
            <div class="user-info-tit">语音信息</div>
            <div class="info-box">
              <div class="info-name">语音总量</div>
              <div class="info">{{ dosageVO.yyTotal }}分钟</div>
            </div>
            <div class="info-box">
              <div class="info-name">语音用量</div>
              <div class="info">{{ dosageVO.yyUse }}分钟</div>
            </div>
            <div class="info-box">
              <div class="info-name">语音剩余量</div>
              <div class="info">{{ dosageVO.yySurplus }}分钟</div>
            </div>
          </div>
          <div class="user-info-box" style="width: 300px;">
            <div class="user-info-tit">数据信息</div>
            <div class="info-box">
              <div class="info-name">数据总量</div>
              <div class="info">{{ dosageVO.sjTotal }}KB</div>
            </div>
            <div class="info-box">
              <div class="info-name">数据用量</div>
              <div class="info">{{ dosageVO.sjUse }}KB</div>
            </div>
            <div class="info-box">
              <div class="info-name">数据剩余量</div>
              <div class="info">{{ dosageVO.sjSurplus }}KB</div>
            </div>
          </div>
          <div class="user-info-box" style="width: 300px;">
            <div class="user-info-tit">短信信息</div>
            <div class="info-box">
              <div class="info-name">短信总量</div>
              <div class="info">{{ dosageVO.dxTotal }}条</div>
            </div>
            <div class="info-box">
              <div class="info-name">短信用量</div>
              <div class="info">{{ dosageVO.dxUse }}条</div>
            </div>
            <div class="info-box">
              <div class="info-name">短信剩余量</div>
              <div class="info">{{ dosageVO.dxSurplus }}条</div>
            </div>
          </div>
          <div class="user-info-box" style="width: 300px;">
            <div class="user-info-tit">彩信信息</div>
            <div class="info-box">
              <div class="info-name">彩信总量</div>
              <div class="info">{{ dosageVO.cxTotal }}条</div>
            </div>
            <div class="info-box">
              <div class="info-name">彩信用量</div>
              <div class="info">{{ dosageVO.cxUse }}条</div>
            </div>
            <div class="info-box">
              <div class="info-name">彩信剩余量</div>
              <div class="info">{{ dosageVO.cxSurplus }}条</div>
            </div>
          </div>
        </div>
        <el-table :data="tableData3" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="agent" label="代理商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="company" label="企业名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" width="90" align="center">
            <template #default="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                          v-if="scope.row.status == '提交失败'">
                <span style="color: #f56c6c;">{{ scope.row.status }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center" width="120">
            <template #default="scope">
              <span v-if="scope.row.type == '停机'" class="status_color2 bgred">{{ scope.row.type }}</span>
              <span v-if="scope.row.type == '复机'"
                    class="status_color2 bggreen">{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operateMsg" label="原因" align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdAt" label="记录时间" align="center" width="155"></el-table-column>
          <el-table-column label="复机" align="center" width="100">
            <template #default="scope">
							<span @click="getRecordVisible(scope.row)"
                    style="cursor: pointer;color: #ff0000;">记录复机</span>
            </template>
          </el-table-column>
          <el-table-column prop="userPhone" label="操作者" align="center" width="130"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="批量查询" v-if="isAdmin||isAgent" name="userInfoBatch">
        <div class="handle-box">
          <el-button size="small" type="primary" :class="[theme]"
                     @click="getbatchQueryRecord">批量查询
          </el-button>
          <a :href="`${path}dxtQuery.txt`" class="down" style="margin:10px 10px;" download="批量查询模板.txt"
             :class="[theme]">
            <i class="el-icon-download"></i>
            下载模板
          </a>
          <el-button size="small" type="primary" :class="[theme]" @click="batchQueryRecords">刷新</el-button>
        </div>
        <el-table :data="tableData2" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
          <el-table-column prop="count" label="总数量" align="center"></el-table-column>
          <el-table-column prop="success" label="成功" align="center"></el-table-column>
          <el-table-column prop="err" label="失败" align="center">
            <template #default="scope">
              <span style="color: #f56c6c;">{{ scope.row.err }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="时间" align="center" width="160"></el-table-column>
          <el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
          <el-table-column label="操作" width="240" align="center">
            <template #default="scope">
              <a :href="scope.row.url" class="down" download="迪迦用户信息批量查询数据.text" :class="[theme]">
                <i class="el-icon-download"></i>
                下载
              </a>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query2.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query2.pageSize" :total="pageTotal2" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="开户审核查询" v-if="isAdmin||isAgent" name="accountReview">
        <div class="handle-box">
          <el-input size="small" v-model="phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                     @click="getauditResult">搜索
          </el-button>
        </div>
        <div class="table-box2" v-if="auditResultData">
          <div class="user-info-box" style="min-width: 500px;">
            <div class="user-info-tit">账户信息</div>
            <div class="info-box">
              <div class="info-name">认证手机号：</div>
              <div class="info">{{ auditResultData.billId }}</div>
            </div>
          </div>
          <div class="user-info-box" style="min-width: 500px;">
            <div class="info-box">
              <div class="info-name">状态：</div>
              <div class="info">{{ auditResultData.status }}</div>
            </div>
          </div>
          <div class="user-info-box" style="min-width: 500px;">
            <div class="info-box">
              <div class="info-name">审核备注：</div>
              <div class="info">
                {{ auditResultData.auditMsg }}
              </div>
            </div>
          </div>
          <div class="user-info-box" style="min-width: 500px;">
            <div class="info-box">
              <div class="info-name">审核时间：</div>
              <div class="info">{{ auditResultData.auditDate }}</div>
            </div>
          </div>
          <div class="user-info-box" style="min-width: 500px;">
            <div class="info-box">
              <div class="info-name">提交时间：</div>
              <div class="info">{{ auditResultData.lastCommitDate }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="停复机" v-if="isAdmin" name="restartRecordList">
        <div class="handle-box">
          <el-select size="small" @change="agentChange" v-model="query3.agentId" filterable clearable
                     placeholder="代理商" class="handle-select mr10" style="width: 260px">
            <el-option v-for="item in agents" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-select size="small" style="width: 260px" v-model="query3.companyId" @change="companyChange"
                     filterable clearable placeholder="企业" class="handle-select mr10">
            <el-option v-for="item in companys" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-input size="small" v-model="query3.phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-input size="small" v-model="query3.uid" clearable placeholder="订单编号" style="width: 230px;"
                    class="handle-input mr10"></el-input>
          <el-select size="small" style="width: 100px" v-model="query3.status" filterable clearable
                     placeholder="类型" class="handle-select mr10">
            <el-option v-for="item in rechargeList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-select size="small" style="width: 100px" v-model="query3.succeed" filterable clearable
                     placeholder="状态" class="handle-select mr10">
            <el-option v-for="item in succeedList2" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-input size="small" v-model="query3.operateMsg" clearable placeholder="请输入原因"
                    class="handle-input mr10" style="width: 180px;"></el-input>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
                     @click="getstopOrOpenRecord">搜索
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
                     @click="handleAdd3">添加停复机
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload2  el-icon--right"
                     @click="exportData" v-if="query3.operateMsg">导出
          </el-button>
        </div>
        <el-table :data="tableData3" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="agent" label="代理商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="company" label="企业名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" width="90" align="center">
            <template #default="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                          v-if="scope.row.status == '提交失败'">
                <span style="color: #f56c6c;">{{ scope.row.status }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center" width="120">
            <template #default="scope">
              <span v-if="scope.row.type == '停机'" class="status_color2 bgred">{{ scope.row.type }}</span>
              <span v-if="scope.row.type == '复机'"
                    class="status_color2 bggreen">{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operateMsg" label="原因" align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdAt" label="记录时间" align="center" width="155"></el-table-column>
          <el-table-column label="复机" align="center" width="100">
            <template #default="scope">
							<span @click="getRecordVisible(scope.row)"
                    style="cursor: pointer;color: #ff0000;">记录复机</span>
            </template>
          </el-table-column>
          <el-table-column prop="userPhone" label="操作者" align="center" width="130"></el-table-column>
          <el-table-column prop="uid" label="订单编号" width="350" align="center">
            <template #default="scope">
							<span style="cursor: pointer;">
								<i @click="getdownloadStopOrOpenRecord(scope.row.uid)" class="el-icon-download"
                   :class="[theme3]" style="margin-right:10px;font-weight: 600;"></i>
								<span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
							</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query3.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query3.pageSize" :total="pageTotal3" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="异常话单" v-if="isAdmin||isAgent" name="DJAbnormalCallList">
        <div class="handle-box">
          <el-select size="small" @change="agentChange" v-if="isAdmin" v-model="query10.agentId" filterable
                     clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
            <el-option v-for="item in agents" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-select size="small" v-if="isSubAgent" v-model="query10.subAgentId"
                     @change="getfetchDefaultCompanies" filterable clearable placeholder="子代理"
                     class="handle-select mr10" style="width: 260px;">
            <el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
          <el-select size="small" style="width: 260px" v-model="query10.companyId" @change="companyChange"
                     filterable clearable placeholder="企业" class="handle-select mr10">
            <el-option v-for="item in companys" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-input size="small" v-model="query10.phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_l_10"
                     @click="getdxtErrRecord">搜索
          </el-button>
        </div>
        <el-table :data="tableData10" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
          <el-table-column prop="companyName" label="企业名称" align="center"></el-table-column>
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
          <el-table-column prop="phoneNumber" label="被叫号码" align="center"></el-table-column>
          <el-table-column prop="time" label="时间" align="center"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query10.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query10.pageSize" :total="pageTotal10" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="充值" v-if="isAdmin" name="djRecharge">
        <div class="handle-box">
          <el-select size="small" @change="agentChange" v-model="singlequery.agentId" filterable clearable
                     placeholder="请选择代理商" class="handle-select mr10" style="width: 260px;">
            <el-option v-for="item in agents" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-select size="small" style="width: 260px;" v-model="singlequery.companyId" filterable clearable
                     placeholder="企业" class="handle-select mr10">
            <el-option v-for="item in companys" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-input size="small" v-model="singlequery.phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-input size="small" v-model="singlequery.uid" clearable placeholder="流水号" style="width: 350px;"
                    class="handle-input mr10"></el-input>
          <el-select size="small" style="width: 100px" v-model="singlequery.status" filterable clearable
                     placeholder="状态" class="handle-select mr10">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="topUpRecord"
                     class="m_t_10">搜索
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getAdd"
                     class="m_t_10">充值
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getAPPAdd"
                     class="m_t_10">APP充值
          </el-button>
        </div>
        <el-table :data="singletableData" border class="table" ref="multipleTable"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="agentName" label="代理商" align="center" min-width="180"></el-table-column>
          <el-table-column prop="companyName" label="企业" align="center" min-width="180"></el-table-column>
          <el-table-column prop="phone" label="用户名" align="center" width="130"></el-table-column>
          <el-table-column prop="amount" label="金额(元)" align="center" width="90"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="90">
            <template #default="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                          v-if="scope.row.status == '失败'">
                <span style="color: #f56c6c;">{{ scope.row.status }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="时间" width="180" align="center"></el-table-column>
          <el-table-column prop="userPhone" label="操作者" align="center" width="130"></el-table-column>
          <el-table-column label="流水号" width="400" align="center">
            <template #default="scope">
							<span style="cursor: pointer;">
								<i @click="gettopUpRecordDownload(scope.row.uid)" class="el-icon-download"
                   :class="[theme3]" style="margin-right:10px;font-weight: 600;"></i>
								<span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
								<span @click="getReturnPremium(scope.row)"
                      style="margin-left: 10px;color: #ff0000;">返销</span>
							</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="singlequery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="singlequery.pageSize" :total="singletotal" @size-change="singlehandleSizeChange"
                         @current-change="singlehandlePageChange"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="批量充值" v-if="isAdmin" name="djBatchRecharge">
        <div class="handle-box">
          <el-button size="small" type="primary" :class="[theme]" @click="getaddVisible">批量充值</el-button>
          <a :href="`${path}batchRecharge.xlsx`" class="down" :class="[theme]" style="margin:10px 10px;"
             download="批量充值模板.xlsx">
            <i class="el-icon-download"></i>
            下载模板
          </a>
          <el-button size="small" type="primary" :class="[theme]" @click="batchTopUpRecords">刷新</el-button>
        </div>
        <el-table :data="batchtableData" border class="table" ref="multipleTable"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
          <el-table-column prop="count" label="总数量" align="center"></el-table-column>
          <el-table-column prop="success" label="成功" align="center"></el-table-column>
          <el-table-column prop="totalSuccess" label="成功金额(元)" align="center"></el-table-column>
          <el-table-column prop="err" label="失败" align="center">
            <template #default="scope">
              <span style="color: #f56c6c;">{{ scope.row.err }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalErr" label="失败金额(元)" align="center">
            <template #default="scope">
              <span style="color: #f56c6c;">{{ scope.row.totalErr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="时间" align="center" width="180"></el-table-column>
          <el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
          <el-table-column label="操作" width="240" align="center">
            <template #default="scope">
              <a :href="scope.row.url" class="down" :class="[theme]" download="迪迦批量充值数据.text">
                <i class="el-icon-download"></i>
                下载
              </a>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="batchquery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="batchquery.pageSize" :total="batchpageTotal" @size-change="batchhandleSizeChange"
                         @current-change="batchhandlePageChange"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="预约激活" v-if="isAdmin" name="appointment">
        <div class="handle-box">
          <el-input size="small" v-model="query16.custName" clearable placeholder="请输入客户姓名" class="mr10"
                    style="width: 180px;"></el-input>
          <el-input size="small" v-model="query16.phoneNum" clearable placeholder="请输入号码" class="mr10"
                    style="width: 180px;"></el-input>
          <el-select size="small" style="width: 180px" v-model="query16.auditStatus" filterable clearable
                     placeholder="是否审核" class="handle-select mr10">
            <el-option v-for="item in auditStatusList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-select size="small" style="width: 180px" v-model="query16.addressInfo" filterable clearable
                     placeholder="是否录入地址" class="handle-select mr10">
            <el-option v-for="item in addressInfoList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-select size="small" style="width: 180px" v-model="query16.shipment" filterable clearable
                     placeholder="是否发货" class="handle-select mr10">
            <el-option v-for="item in shipmentList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                     @click="getShipmentList">搜索
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
                     @click="getreviewInfo">导出
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload"
                     @click="getshipmentUpload">导入
          </el-button>


        </div>
        <el-table :data="tableData16" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  @selection-change="handleSelectionChange" v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="phoneNum" label="手机号码" align="center" width="140"></el-table-column>
          <el-table-column prop="custName" label="客户姓名" align="center" width="140"></el-table-column>
          <el-table-column prop="auditStatus" label="状态" align="center" width="140">
            <template #default="scope">
              <el-tag type="success" v-if="scope.row.auditStatus" size="small">审核通过</el-tag>
              <el-tooltip class="item" effect="dark" :content="scope.row.auditMsg" placement="top" v-else>
                <el-tag type="danger" size="small">审核未通过</el-tag>
              </el-tooltip>
              <!-- @click="getAddForm16Visible(scope.row)" -->
            </template>
          </el-table-column>
          <el-table-column prop="address" label="收件地址" align="center"></el-table-column>
          <el-table-column prop="phone" label="收件号码" align="center" width="140"></el-table-column>
          <el-table-column prop="trackingNumber" label="快递单号" align="center">
            <template #default="scope">
							<span @click="getLogisticsInfo(scope.row)"
                    style="cursor: pointer;">{{ scope.row.trackingNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="logisticsCompany" label="物流公司" align="center">
            <template #default="scope">
              <span v-if="scope.row.logisticsCompany=='SF'">顺丰速运</span>
              <span v-if="scope.row.logisticsCompany=='ZT'">中通快递</span>
              <span v-if="scope.row.logisticsCompany=='YT'">圆通速递</span>
              <span v-if="scope.row.logisticsCompany=='ST'">申通快递</span>
              <span v-if="scope.row.logisticsCompany=='YD'">韵达快递</span>
              <span v-if="scope.row.logisticsCompany=='JD'">京东物流</span>
              <span v-if="scope.row.logisticsCompany=='JT'">极兔速递</span>
              <span v-if="scope.row.logisticsCompany=='SFEMS'">邮政EMS</span>
            </template>
          </el-table-column>
          <el-table-column prop="auditTime" label="时间" align="center" width="160"></el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="scope">

						<span v-if="scope.row.trackingNumber && scope.row.logisticsCompany" style="cursor: pointer;">
						    <span @click="getClearLogisticsInfo(scope.row,1)"
                      style="margin-left: 10px;color: #ff0000;">清除物流</span>
						</span>

              <span
                  v-if="scope.row.address && scope.row.phone && !scope.row.trackingNumber&&!scope.row.logisticsCompany"
                  style="cursor: pointer;">
						    <span @click="getClearLogisticsInfo(scope.row,2)"
                      style="margin-left: 10px;color: #ff0000;">清除地址</span>
						</span>
            </template>
          </el-table-column>
          <!-- 	<el-table-column label="流水号" width="400" align="center">
						<template #default="scope">
							<span style="cursor: pointer;">
								<i @click="gettopUpRecordDownload(scope.row.uid)" class="el-icon-download"
									:class="[theme3]" style="margin-right:10px;font-weight: 600;"></i>
								<span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
								<span @click="getReturnPremium(scope.row)"
									style="margin-left: 10px;color: #ff0000;">返销</span>
							</span>
						</template>
					</el-table-column> -->
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query16.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query16.pageSize" :total="pageTotal16" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>


      <el-tab-pane label="限制返档" v-if="isAdmin||isAgent" name="activationList">
        <div class="handle-box">
          <el-input size="small" v-model="query4.phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-input size="small" v-model="query4.uid" clearable placeholder="订单编号" style="width: 320px;"
                    class="handle-input mr10"></el-input>
          <el-select size="small" style="width: 160px" v-model="query4.type" filterable clearable
                     placeholder="充值类型" class="handle-select mr10">
            <el-option v-for="item in rechargeList4" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-select size="small" style="width: 160px" v-model="query4.succeed" filterable clearable
                     placeholder="状态" class="handle-select mr10">
            <el-option v-for="item in succeedList2" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                     @click="getactivateRecord">搜索
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus"
                     @click="handleAdd4">添加返档
          </el-button>
        </div>
        <el-table :data="tableData4" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
          <el-table-column prop="operateMsg" label="操作原因" align="center"></el-table-column>
          <el-table-column prop="type" label="类型" align="center">
            <template #default="scope">
							<span v-if="scope.row.type == '限制激活'"
                    class="status_color2 bgred">{{ scope.row.type }}</span>
              <span v-if="scope.row.type == '取消限制激活'"
                    class="status_color2 bggreen">{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template #default="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                          v-if="scope.row.status == false">
                <span style="color: #f56c6c;">失败</span>
              </el-tooltip>
              <span v-else>成功</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="时间" align="center" width="160"></el-table-column>
          <el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
          <el-table-column prop="uid" label="订单编号" width="370" align="center">
            <template #default="scope">
							<span style="cursor: pointer;">
								<i @click="getdownloadActivateRecord(scope.row.uid)" :class="[theme3]"
                   class="el-icon-download" style="margin-right:10px;font-weight: 600;"></i>
								<span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
							</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query4.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query4.pageSize" :total="pageTotal4" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="自选套餐冻结" v-if="isAdmin||isAgent" name="DJfreeze">
        <div class="handle-box">
          <el-select size="small" style="width: 120px" v-model="query11.type" filterable placeholder="状态"
                     class="handle-select mr10" @change="getfrozenRecord">
            <el-option v-for="item in freezeTypeList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-input size="small" v-model="query11.uid" clearable maxlength="12" placeholder="请输入uid"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-input size="small" v-model="query11.phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-select size="small" style="width: 100px" v-model="query11.status" filterable clearable
                     placeholder="状态" class="handle-select mr10" v-if="query11.type==1">
            <el-option v-for="item in succeedList2" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
                     @click="getfrozenRecord">搜索
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
                     @click="handleAdd11">添加冻结
          </el-button>
        </div>
        <div v-if="query11.type==1">
          <el-table :data="tableData11" border class="table" ref="multipleTable" max-height="600"
                    header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                    :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                    v-loading="loading">
            <el-table-column prop="uid" label="UID" align="center"></el-table-column>
            <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
            <el-table-column prop="type" label="类型" align="center">
              <template #default="scope">
								<span v-if="scope.row.type == '冻结'"
                      class="status_color2 bgred">{{ scope.row.type }}</span>
                <span v-if="scope.row.type == '解冻'"
                      class="status_color2 bggreen">{{ scope.row.type }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template #default="scope">
                <span style="color: #f56c6c;" v-if="scope.row.status == false">失败</span>
                <span v-else>成功</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column prop="errMsg" label="失败原因" align="center"></el-table-column>
            <el-table-column prop="createdAt" label="记录时间" align="center" width="175"></el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-table :data="tableData11" border class="table" ref="multipleTable" max-height="600"
                    header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                    :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                    v-loading="loading">
            <el-table-column prop="uid" label="UID" align="center"></el-table-column>
            <el-table-column prop="total" label="总数" align="center"></el-table-column>
            <el-table-column prop="success" label="成功" align="center"></el-table-column>
            <el-table-column prop="fail" label="失败" align="center"></el-table-column>
            <el-table-column prop="time" label="时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="scope">
                <el-button size="small" type="text" icon="el-icon-upload2"
                           @click="handleExport(scope.row)">导出
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query11.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query11.pageSize" :total="pageTotal11" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="取消停机保号" v-if="isAdmin" name="NoShutdownMaintenanceNumber">
        <div class="handle-box">
          <el-input size="small" v-model="query5.phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
                     @click="getcancelProtectionList">搜索
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="handleAdd5">取消停机保号</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getMaintenanceSet"
                     class="m_t_10">停机保号设置
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="showDxtPackage"
                     class="m_t_10">迪加套餐
          </el-button>
        </div>
        <el-table :data="tableData5" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template #default="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                          v-if="scope.row.status == '失败'">
                <span style="color: #f56c6c;">{{ scope.row.status }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center"></el-table-column>
          <el-table-column prop="time" label="时间" align="center"></el-table-column>
          <el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query5.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query5.pageSize" :total="pageTotal5" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="漫游管控" v-if="isAdmin||isAgent" name="numberControl">
        <div class="handle-box">
          <el-input size="small" v-model="query12.phone" clearable maxlength="12" placeholder="电话号码"
                    class="handle-input mr10"></el-input>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                     @click="getopenControlList">搜索
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="handleAdd12">添加</el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-delete"
                     @click="batchDel">批量删除
          </el-button>
        </div>
        <el-table :data="tableData12" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
                  @selection-change="handleSelectionChange" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" stripe v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="phone" label="电话号码" align="center"></el-table-column>
          <el-table-column prop="city" label="城市" align="center"></el-table-column>
          <el-table-column prop="time" label="时间" align="center"></el-table-column>
          <el-table-column prop="userPhone" label="添加人" align="center"></el-table-column>
          <el-table-column label="操作" width="190" align="center">
            <template #default="scope">
              <el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
                         @click="separateDelete(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query12.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query12.pageSize" :total="pageTotal12" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="接通限频" v-if="isAdmin" name="frequencyLimit">
        <div class="handle-box">
          <el-input size="small" v-model="query15.phone" clearable placeholder="请输入号码" class="mr10"
                    style="width: 180px;"></el-input>
          <el-select size="small" style="width: 180px" v-model="query15.sus" filterable clearable
                     placeholder="状态" class="handle-select mr10">
            <el-option v-for="item in susList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-select size="small" style="width: 180px" v-model="query15.type" filterable clearable
                     placeholder="类型" class="handle-select mr10">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                     @click="getdeptParam">查询
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload"
                     @click="getImport">导入号码
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-delete"
                     @click="showBatchDeletefrequency">批量删除
          </el-button>
        </div>
        <el-table :data="tableData15" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  @selection-change="handleSelectionChange" v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
          <el-table-column prop="callNum" label="接通限频" align="center"></el-table-column>
          <el-table-column prop="type" label="类型" align="center">
            <template #default="scope">
              <el-tag type="success" v-if="scope.row.type=='AM'" size="small">添加</el-tag>
              <el-tag type="danger" v-if="scope.row.type=='D'" size="small">删除</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sus" label="状态" align="center">
            <template #default="scope">
              <el-tag type="success" v-if="scope.row.sus" size="small">成功</el-tag>
              <el-tag type="danger" v-else size="small">失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="errMsg" label="错误原因" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdAt" label="时间" align="center"></el-table-column>
          <el-table-column prop="operator" label="操作人" align="center"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query15.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query15.pageSize" :total="pageTotal15" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="返销记录" v-if="isAdmin" name="djRebateList">
        <div class="handle-box">
          <el-input size="small" v-model="query9.phone" clearable maxlength="12" placeholder="号码"
                    style="width: 180px;" class="handle-input mr10"></el-input>
          <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                     @click="getReturnPremiumRecord" class="m_t_10">搜索
          </el-button>
        </div>
        <el-table :data="tableData9" border class="table" ref="multipleTable" max-height="600"
                  header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                  :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                  v-loading="loading">
          <el-table-column prop="phone" label="号码" align="center"></el-table-column>
          <el-table-column prop="amount" label="金额(元)" align="center"></el-table-column>
          <el-table-column prop="time" label="时间" align="center"></el-table-column>
          <el-table-column label="流水号" align="center">
            <template #default="scope">
							<span style="cursor: pointer;">
								<span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
							</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                         :current-page="query9.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                         :page-size="query9.pageSize" :total="pageTotal9" @size-change="handleSizeChange"
                         @current-change="handlePageChange"></el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="套餐管理" v-if="isAdmin" name="dxtPackages">
        <DxtPackagesManagement />
      </el-tab-pane>
      <el-tab-pane label="充值套餐" v-if="isAdmin" name="dxtPackageTopUp">
        <DxtPackageTopUp />
      </el-tab-pane>
      <el-tab-pane label="资金池" v-if="isAdmin" name="djCapitalPool">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-row :gutter="20" class="mgb20">
              <el-col :span="8">
                <el-card shadow="hover" :body-style="{ padding: '0px' }">
                  <div class="grid-content grid-con-2">
                    <i class="el-icon-receiving grid-con-icon"></i>
                    <div class="grid-cont-right">
                      <div class="grid-num" :class="theme3">{{ capitaltotal || 0 }}</div>
                      <div>剩余量</div>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <el-button size="small" type="primary" :class="[theme]"
                       @click="addCapital">添加金额
            </el-button>
          </el-col>
        </el-row>
        <div class="container">
          <el-table v-loading="loading" :data="capitaltableData" border class="table m_t_20"
                    header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                    :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ padding: '6px' }" stripe>
            <el-table-column prop="label" label="数量" align="center">
              <template #default="scope">
                <span>{{ scope.row.label }}元</span>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="时间" align="center"></el-table-column>
          </el-table>
        </div>

        <el-dialog title="添加金额" v-model="addCapitalNum" width="450px" @close="closeCapitalNum"
                   :close-on-click-modal="false">
          <el-form :model="capitalForm" ref="form" label-width="100px">
            <el-form-item label="添加金额">
              <el-input size="small" style="width: 250px;" placeholder="请输入添加金额"
                        v-model="capitalForm.amount"></el-input>
              <span class="m_l_10">元</span>
            </el-form-item>
            <div class="dis-end">
              <el-button size="small" class="btn" @click="closeCapitalNum">取消</el-button>
              <el-button size="small" class="btn" :class="[theme]" style="border: none;" type="success"
                         @click="getcapitalPoolAdd">确定
              </el-button>
            </div>
          </el-form>
        </el-dialog>
      </el-tab-pane>

    </el-tabs>
    <el-dialog title="物流信息" v-model="logisticsInfoVisible" width="500px" :close-on-click-modal="false">
      <el-timeline reverse="true" v-if="logisticsInfoList?.length">
        <el-timeline-item v-for="(item, index) in logisticsInfoList" :key="index" :timestamp="item.opTime">
          {{ item.memo }}
        </el-timeline-item>
      </el-timeline>
      <el-timeline reverse="true" v-if="logisticsInfoList2?.length">
        <el-timeline-item v-for="(item, index) in logisticsInfoList2" :key="index" :timestamp="item.acceptTime">
          {{ item.acceptAddress }}:{{ item.remark }}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
    <el-dialog title="预约导入" v-model="shipmentUpload" width="500px" :close-on-click-modal="false">
      <el-form label-width="100px" :model="shipmentForm" ref="shipmentForm">
        <el-form-item label="物流公司">
          <el-select size="small" v-model="uploadData16.logisticsCompany" filterable clearable
                     placeholder="请选择物流公司" style="width: 100%">
            <el-option v-for="item in logisticsCompanyList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传文件">
          <el-upload ref="upload16" action="/api/dxt/import-shipment-info" :headers="token" :limit="1"
                     :on-success="uploadSuccess16" :on-preview="handlePreview16" :on-remove="handleRemove16"
                     :auto-upload="false" :data="uploadData16">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 70px;">选择文件
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item style="display: flex;flex-direction: row;justify-content: end;">
          <el-button size="small" @click="closeShipmentUploadDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="submitUpload16">确认导入</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="预约导入" v-model="shipmentUpload2" width="500px" :close-on-click-modal="false">
      <el-form label-width="100px" :model="shipmentForm" ref="shipmentForm">
        <el-form-item label="物流公司">
          <el-select size="small" v-model="shipmentForm.logisticsCompany" filterable clearable
                     placeholder="请选择物流公司" style="width: 100%">
            <el-option v-for="item in logisticsCompanyList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input size="small" :rows="5" type="textarea" v-model="shipmentForm.trackingNumber"
                    auto-complete="off" placeholder="请输入物流单号" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item style="display: flex;flex-direction: row;justify-content: end;">
          <el-button size="small" @click="getshipmentUpload2">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]"
                     @click="getImportShipmentInfo">确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="收货信息" v-model="addForm16Visible" @close="closeAddForm16Dialog" width="450px">
      <el-form label-width="80px" :model="addForm16" ref="addForm16">
        <el-form-item label="收货人" prop="custName">
          <el-input size="small" v-model="addForm16.custName" placeholder="请输入收货人姓名" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input size="small" v-model="addForm16.phone" placeholder="请输入收货人手机号"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="address">
          <el-input size="small" v-model="addForm16.address" type="textarea" rows="5" placeholder="请输入收货地址"
                    style="width: 100%" @input="bulrInspectionAddress">
          </el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" type="primary" @click="getInspectionAddress"
                     v-if="inspectionAddressBtn">地址校验
          </el-button>
          <el-button size="small" @click="closeAddForm16Dialog"
                     v-if="!inspectionAddressBtn&&addForm16.address">取消
          </el-button>
          <el-button size="small" type="primary" v-if="!inspectionAddressBtn&&addForm16.address"
                     @click="getMailing">确定
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="批量查询" v-model="addVisible1" width="520px" @close="closeDialog1">
      <el-form label-width="120px" :model="addForm1" ref="addForm1">
        <el-form-item label="上传类型" prop="type">
          <el-radio-group v-model="addForm1.type">
            <el-radio label="2">手动输入</el-radio>
            <el-radio label="1">批量查询模板</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传文件" prop="type" v-if="addForm1.type=='1'">
          <el-upload ref="upload1" action="/api/dxt/batchQuery" :headers="token" :limit="1"
                     :on-success="uploadSuccess1" :auto-upload="false" :data="uploadData1">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="批量查询" v-if="addForm1.type=='2'">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm1.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog1">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" v-if="addForm1.type == '2'"
                     @click="getbatchQuery">确定
          </el-button>
          <el-button v-else size="small" type="primary" :class="[theme]" @click="submitUpload1">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加停复机" v-model="addVisible3" width="520px" @close="closeDialog3">
      <el-form label-width="120px" :model="addForm3" ref="addForm3">
        <el-form-item label="选择模式" prop="tab1">
          <el-radio-group v-model="tab1">
            <el-radio label="input">手动输入</el-radio>
            <el-radio label="fled">批量停开机模板</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="addForm3.type">
            <el-radio label="OPEN">开机</el-radio>
            <el-radio label="STOP">停机</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm3.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="" v-else>
          <el-upload ref="upload3" action="/api/dxt/FileStopOrOpen" :headers="token" :limit="1"
                     :on-success="uploadSuccess3" :auto-upload="false" :data="addForm3">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top:40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="原因" prop="operateMsg">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm3.operateMsg" auto-complete="off"
                    placeholder="请输入停复机原因"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog3">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
                     @click="getstopOrOpens3">确定
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" v-else @click="submitUpload3">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="自动复机设置" v-model="repeatedVisible" width="520px" @close="closeDialog3">
      <el-form label-width="120px" :model="repeatedForm" ref="repeatedForm">
        <el-form-item label="是否记录" prop="record">
          <el-radio-group v-model="repeatedForm.record">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否复机" prop="recover">
          <el-radio-group v-model="repeatedForm.recover" disabled>
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="复机时间" prop="hours" v-if="repeatedForm.record">
          <el-radio-group v-model="repeatedForm.hours">
            <el-radio v-for="item in hoursList" :key="item.value" :label="item.value" :value="item.value"
                      style="margin: 12px 52px 12px 0;">{{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="记录时间" prop="updatedAt">
          <el-input size="small" v-model="repeatedForm.updatedAt" disabled></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog3">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getRecordingRecover">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加限制激活" v-model="addVisible4" width="520px" @close="closeDialog4">
      <el-form label-width="120px" :model="addForm4" ref="addForm4">
        <el-form-item label="选择模式" prop="tab1">
          <el-radio-group v-model="tab1">
            <el-radio label="input">手动输入</el-radio>
            <el-radio label="fled">批量返档模板</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="addForm4.activate">
            <el-radio label="OFF">限制激活</el-radio>
            <el-radio label="ON">取消限制激活</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm4.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="" v-else>
          <el-upload ref="upload4" action="/api/dxt/batchActivate" :headers="token" :limit="1"
                     :on-success="uploadSuccess4" :auto-upload="false" :data="addForm4">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="原因" prop="operateMsg">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm4.operateMsg" auto-complete="off"
                    placeholder="请输入操作原因"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog4">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
                     @click="getstopOrOpens4">确定
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" v-else @click="submitUpload4">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="取消停机保号" v-model="addVisible5" width="520px" @close="closeDialog5">
      <el-form label-width="120px" :model="addForm5" ref="addForm5">
        <el-form-item label="选择模式" prop="tab1">
          <el-radio-group v-model="tab1">
            <el-radio label="input">手动输入</el-radio>
            <el-radio label="fled">文件上传</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm5.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="" v-else>
          <el-upload ref="upload5" action="/api/dxt/FileCancel" :headers="token" :limit="1"
                     :on-success="uploadSuccess5" :auto-upload="false" :data="addForm5">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="原因" prop="remark">
          <el-input size="small" :rows="2" type="textarea" v-model="addForm5.remark" auto-complete="off"
                    placeholder="请输入取消停机保号原因"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog5">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
                     @click="submitAdd">确定
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" v-else @click="submitUpload5">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="停机保号设置" v-model="maintenanceVisible" width="450px" @close="closeMaintenanceDialog">
      <el-form label-width="120px" :model="maintenanceForm" ref="maintenanceForm">
        <el-form-item label="自动取消停机保号:" prop="enable">
          <el-radio-group v-model="maintenanceForm.enable">
            <el-radio :label="true">开启</el-radio>
            <el-radio :label="false">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeMaintenanceDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="updateCancellation">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="批量充值" v-model="addVisible7" width="520px" @close="closeDialog7">
      <el-form label-width="120px" :model="addForm7" ref="addForm7">
        <el-form-item label="上传文件" prop="">
          <el-upload ref="upload7" action="/api/dxt/batchTopUp" :headers="token" :limit="1"
                     :on-success="uploadSuccess7" :auto-upload="false" :data="uploadData7">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入xlsx文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog7">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="submitUpload7">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="充值" v-model="singleVisible" width="450px" @close="closesingleDialog">
      <el-form label-width="120px" :model="singleForm" ref="editForm">
        <el-form-item label="手机号">
          <el-input size="small" style="width: 250px;" placeholder="请输入手机号"
                    v-model="singleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="添加金额">
          <el-input v-model="singleForm.amount" size="small" style="width: 250px;" placeholder="请输入金额"
                    οninput="value=value.replace(/[^0-9]/g,'')"/>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closesingleDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="AddtopUp">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="APP充值" v-model="APPVisible" width="450px" @close="closeAPPDialog">
      <el-form label-width="120px" :model="APPForm" ref="editForm">
        <el-form-item label="APP充值:" prop="bon">
          <el-radio-group v-model="APPForm.bon">
            <el-radio :label="true">开启</el-radio>
            <el-radio :label="false">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeAPPDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getstopDxtApp">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加冻结" v-model="addVisible11" width="520px" @close="closeDialog11">
      <el-form label-width="120px" :model="addForm11" ref="addForm11">
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="addForm11.type">
            <el-radio label="1">冻结</el-radio>
            <el-radio label="0">解冻</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号码" prop="phones">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm11.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <el-form-item label="原因" prop="remark">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm11.remark" auto-complete="off"
                    placeholder="请输入冻结/解冻原因"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog11">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getFrozen">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加" v-model="addVisible12" width="650px" @close="closeDialog12">
      <el-form :model="addForm12" ref="addForm12" label-width="120px">
        <el-form-item label="" prop="">
          <span style="color: #ff0000;font-size: 12px;">*注释:收件地址地市与漫游地，不一致，将会漫游地异常停机</span>
        </el-form-item>
        <el-form-item label="收货地市">
          <el-input size="small" v-model="addForm12.city" placeholder="请输入收货地市"></el-input>
        </el-form-item>
        <el-form-item label="添加号码">
          <el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码,一次最多添加100个号码"
                    v-model="addForm12.phones"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog12">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getAdd12">添加</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="批量删除" v-model="deleteVisible12" width="800px" @close="closeDialog12"
               :close-on-click-modal="false">
      <el-form :model="deleteForm12" :rules="rules" ref="deleteForm12" label-width="100px">
        <el-form-item label="删除号码" prop="phones">
          <el-input size="small" type="textarea" :rows="5" placeholder="一行一个删除单号码,一次最多删除100个号码"
                    v-model="deleteForm12.phones"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" type="primary" :class="[theme]" @click="closeDialog12">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="batchDel2">确认删除</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="导入号码" v-model="frequencyLimitVisible" width="520px" @close="closefrequencyLimitDialog">
      <el-form label-width="120px" :model="frequencyLimitForm" ref="frequencyLimitForm">
        <el-form-item label="频次" v-if="deletefrequencyLimitDowm">
          <el-input size="small" placeholder="请输入限频次数" v-model="frequencyLimitForm.callNum" filterable
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="号码">
          <el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码"
                    v-model="frequencyLimitForm.phones"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closefrequencyLimitDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getAddFrequencyLimit"
                     v-if="deletefrequencyLimitDowm">确定
          </el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="batchDeletefrequencyLimit2"
                     v-else>批量删除
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="迪加套餐" v-model="dxtPackageVisible" width="850px" @close="closeDxtPackageDialog">
      <el-form label-width="120px" :model="dxtPackageForm" ref="dxtPackageForm">
        <el-form-item label="套餐" prop="cardsId" v-for="(item,index) in dxtPackageForm.menuList" :key="index">
          <el-input size="small" style="width: 200px;margin-right: 10px;margin-top: 4px;" v-model="item.value"
                    placeholder="请输入套餐金额">
            <template #append>元</template>
          </el-input>
          <el-button type="primary" icon="el-icon-plus" size="small" @click.prevent="addDomain()"/>
          <el-button type="danger" icon="el-icon-minus" size="small" @click.prevent="removeDomain(item)"/>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDxtPackageDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="updateDxtPackages">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import {
  fetchDepartment
} from '../api/index';
import {
  fetchAgent
} from '../api/agentIndex';
import {
  fetchCompanyByAgentId,
  fetchDefaultCompanies
} from '../api/companyIndex';
import {
  dxtQuery,
  batchQueryRecord,
  dxtbatchQuery,
  stopOrOpenRecord,
  stopOrOpen,
  downloadStopOrOpenRecord,
  dxtRecordingRecover,
  WNdownloadStopOrOpenRecord,
  activateRecord,
  downloadActivateRecord,
  getactivate,
  getbatchActivate,
  cancelProtection,
  cancelProtectionList,
  updateCancellation,
  getCancellation,
  fundPoolAdd,
  fundPool,
  topUpRecord,
  batchTopUpRecord,
  topUpRecordDownload,
  AddtopUp,
  stopDxtApp,
  dxtEnabled,
  ReturnPremium,
  ReturnPremiumRecord,
  dxtErrRecord,
  frozen,
  frozenRecord,
  auditResult,
  deptParam,
  AddFrequencyLimit,
  deleteBatch,
  frozenRecordDownload,
  getDxtPackage,
  updateDxtPackage,
  ShipmentList,
  reviewInfo,
  importShipmentInfo,
  logisticsInfo,
  clearLogisticsInfo
} from '../api/dijia.js';
import {
  openControl,
  openControlList,
  openControlDelete
} from '../api/index.js';
import DxtPackagesManagement from './DxtPackagesManagement.vue';
import DxtPackageTopUp from './DxtPackageTopUp.vue';

export default {
  components: {
    DxtPackagesManagement,
    DxtPackageTopUp
  },
  name: 'DJvirtualCommerce',
  data() {
    return {
      loading: false,
      theme: localStorage.getItem('theme'),
      theme3: localStorage.getItem('theme3'),
      theme8: localStorage.getItem('theme8'),
      phone: '',
      query1: {
        pageIndex: 1,
        pageSize: 10,
        userId: localStorage.getItem('user'),
      },
      dxtDet: '',
      uploadData1: {
        userId: localStorage.getItem('user'),
      },
      addVisible1: false,
      dosageVO: '',
      addForm1: {
        userId: localStorage.getItem('user'),
        phones: '',
        type: '2',
      },
      pageTotal2: 0,
      tableData2: [],
      query2: {
        pageIndex: 1,
        pageSize: 10,
        userId: localStorage.getItem('user'),
      },
      query3: {
        companyId: '',
        agentId: '',
        userId: localStorage.getItem('user'),
        status: '',
        phone: '',
        pageIndex: 1,
        pageSize: 10,
        uid: '',
        succeed: '',
        operateMsg: '',
      },
      addForm3: {
        phones: '',
        userId: localStorage.getItem('user'),
        operateMsg: '',
        type: 'OPEN',
      },
      tableData3: [],
      pageTotal3: 0,
      rechargeList: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '复机'
      }, {
        value: -1,
        label: '停机'
      }],

      susList: [{
        value: null,
        label: '全部'
      }, {
        value: true,
        label: '成功'
      }, {
        value: false,
        label: '失败'
      }],
      typeList: [{
        value: null,
        label: '全部'
      }, {
        value: 'AM',
        label: '添加'
      }, {
        value: 'D',
        label: '删除'
      }],
      addVisible3: false,
      tab1: 'input',
      delList: [],
      repeatedVisible: false,
      repeatedForm: {
        record: false,
        recover: false,
        updatedAt: '',
        hours: '',
      },
      hoursList: [{
        value: 2,
        label: '2小时'
      }, {
        value: 4,
        label: '4小时'
      }, {
        value: 6,
        label: '6小时'
      },
        {
          value: 12,
          label: '12小时'
        }, {
          value: 24,
          label: '24小时'
        }
      ],
      query4: {
        type: '',
        phone: '',
        uid: '',
        succeed: '',
        pageIndex: 1,
        pageSize: 10,
        userId: localStorage.getItem('user'),
      },
      tableData4: [],
      addForm4: {
        phones: '',
        userId: localStorage.getItem('user'),
        operateMsg: '',
        activate: 'OFF',
      },
      pageTotal4: 0,
      rechargeList4: [{
        value: 0,
        label: '全部'
      }, {
        value: 'ON',
        label: '取消限制激活'
      }, {
        value: 'OFF',
        label: '限制激活',
      }],
      addVisible4: false,
      query5: {
        userId: localStorage.getItem('user'),
        phone: '',
        pageIndex: 1,
        pageSize: 10,
      },
      tableData5: [],
      pageTotal5: 0,
      addForm5: {
        phones: '',
        userId: localStorage.getItem('user'),
        remark: '',
      },
      addVisible5: false,
      maintenanceVisible: false,
      maintenanceForm: {
        enable: false,
        userId: localStorage.getItem('user'),
      },
      singlequery: {
        pageIndex: 1,
        pageSize: 10,
        userId: localStorage.getItem('user'),
        uid: '',
        status: '',
        agentId: '',
        companyId: '',
      },
      singletableData: [],
      singletotal: 0,
      statusList: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '成功'
      }, {
        value: -1,
        label: '失败'
      }],
      singleVisible: false,
      singleForm: {
        userId: localStorage.getItem('user'),
        phone: '',
        amount: '',
      },
      batchquery: {
        pageIndex: 1,
        pageSize: 10,
      },
      batchtableData: [],
      batchpageTotal: 0,
      uploadData7: {
        userId: localStorage.getItem('user'),
      },
      addVisible7: false,
      tableData7: [],
      pageTotal7: 0,
      query7: {
        pageIndex: 1,
        pageSize: 10,
        userId: localStorage.getItem('user'),
      },
      addCapitalNum: false,
      capitalForm: {
        amount: '',
      },
      capitaltableData: [],
      capitaltotal: '',
      APPVisible: false,
      APPForm: {
        bon: false,
      },
      tableData9: [],
      pageTotal9: 0,
      query9: {
        phone: '',
        userId: localStorage.getItem('user'),
        pageIndex: 1,
        pageSize: 10,
      },
      query10: {
        companyId: '',
        agentId: '',
        userId: localStorage.getItem('user'),
        phone: '',
        pageIndex: 1,
        pageSize: 10,
        subAgentId: '',
      },
      tableData10: [],
      pageTotal10: 0,
      query11: {
        userId: localStorage.getItem('user'),
        status: '',
        phone: '',
        type: 1,
        uid: '',
        pageIndex: 1,
        pageSize: 10,
      },
      freezeTypeList: [{
        value: 1,
        label: '明细记录'
      }, {
        value: 2,
        label: '批量记录'
      }],
      tableData11: [],
      pageTotal11: 0,
      addForm11: {
        phones: '',
        userId: localStorage.getItem('user'),
        remark: '',
        type: '1',
      },
      addVisible11: false,
      query12: {
        phone: '',
        pageIndex: 1,
        pageSize: 10,
        userId: localStorage.getItem('user'),
      },
      tableData12: [],
      pageTotal12: 0,
      addVisible12: false,
      addForm12: {
        phones: '',
        city: '',
        userId: localStorage.getItem('user'),
      },
      deleteVisible12: false, //批量删除
      deleteForm12: {
        ids: "",
        phones: "",
      },
      auditResultData: "",
      timeArr: [],
      multipleSelection: [],
      path: process.env.BASE_URL,
      token: {
        Authorization: localStorage.getItem('token'),
        type: 'web',
        UserRole: localStorage.getItem('ms_role'),
        XSecurityVersion: 'v2',
      },
      upload: false,
      isAdmin: false,
      isAgent: false,
      isCompany: false,
      isNormal: false,
      isSubAgent: false,
      activeName: 'userInfo',
      agents: [],
      companys: [],
      departments: [],
      query15: {
        userId: localStorage.getItem('user'),
        phone: '',
        type: '',
        pageIndex: 1,
        pageSize: 10,
      },
      deletefrequencyLimitDowm: false,
      frequencyLimitVisible: false,
      paramType: '',
      succeedList: '',
      succeedList2: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '成功'
      }, {
        value: -1,
        label: '失败'
      }],
      succeedList3: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '已限频'
      }, {
        value: -1,
        label: '未限频'
      }],
      frequencyLimitForm: {
        userId: localStorage.getItem('user'),
        callNum: '',
        phones: '',
      },
      tableData15: [],
      pageTotal15: 0,
      dxtPackageVisible: false,
      dxtPackageForm: {
        prices: [],
        menuList: [{
          value: ''
        }],
      },
      tableData16: [],
      pageTotal16: 0,
      query16: {
        phoneNum: '',
        custName: '',
        auditStatus: '',
        addressInfo: '',
        shipment: '',
        pageIndex: 1,
        pageSize: 10,
      },
      addressInfoList: [{
        value: 1,
        label: '已录入'
      }, {
        value: 2,
        label: '未录入'
      }],
      auditStatusList: [{
        value: 1,
        label: '审核通过'
      }, {
        value: 2,
        label: '审核未通过'
      }],
      shipmentList: [{
        value: 1,
        label: '已发货'
      }, {
        value: 2,
        label: '未发货'
      }],

      addForm16Visible: false,
      addForm16: {
        phone: '',
        address: '',
        custName: '',
      },
      inspectionAddressBtn: false,
      upload16: false,
      shipmentUpload: false,
      shipmentUpload2: false,
      shipmentForm: {},
      logisticsCompanyList: [{
        value: 'ST',
        label: '申通快递'
      }, {
        value: 'SF',
        label: '顺丰速运'
      }, {
        value: 'ZT',
        label: '中通快递'
      }, {
        value: 'YT',
        label: '圆通速递'
      }, {
        value: 'YD',
        label: '韵达快递'
      }, {
        value: 'JD',
        label: '京东物流'
      }, {
        value: 'JT',
        label: '极兔速递'
      }, {
        value: 'EMS',
        label: '邮政EMS'
      }],
      uploadData16: {
        logisticsCompany: '',
      },
      logisticsInfoVisible: false,
      logisticsInfoList: [],
      logisticsInfoList2: [],
    };
  },
  created() {
    let role = localStorage.getItem('ms_role');
    this.init();
    if (role === 'admin') {
      this.isAdmin = true;
    }
    if (role === 'agent') {
      this.isAgent = true;
    }
    if (role === 'normal') {
      this.isNormal = true;
    }
    if (role === 'company') {
      this.isCompany = true;
    }
    this.updateTabStyle();
    this.updatePaginationStyle();
  },
  methods: {
    updatePaginationStyle() {
      let pagination = document.getElementById('pagination');
      if (!pagination) {
        pagination = document.createElement('style');
        pagination.id = 'dynamic-tab-style';
        document.head.appendChild(pagination);
      }
      pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
    },
    updateTabStyle() {
      // 动态更新样式
      let styleEl = document.getElementById('dynamic-tab-style');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'dynamic-tab-style';
        document.head.appendChild(styleEl);
      }

      styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
    },
    handleClick(tab, event) {
      this.activeName = tab.props.name;
      this.multipleSelection = [];
      if (tab.props.name == 'userInfo') {
        this.tableData3 = [];
        if (this.phone) {
          this.dxtQuerys();
        }
      } else if (tab.props.name == 'userInfoBatch') {
        this.batchQueryRecords();
      } else if (tab.props.name == 'restartRecordList') {
        this.init();
        this.query3.agentId = '';
        this.query3.companyId = '';
        this.getstopOrOpenRecord();
      } else if (tab.props.name == 'activationList') {
        this.getactivateRecord();
      } else if (tab.props.name == 'NoShutdownMaintenanceNumber') {
        this.getcancelProtectionList();
      } else if (tab.props.name == 'djRecharge') {
        this.init();
        this.singlequery.agentId = '';
        this.singlequery.companyId = '';
        this.topUpRecord();
      } else if (tab.props.name == 'djBatchRecharge') {
        this.batchTopUpRecords();
      } else if (tab.props.name == 'djCapitalPool') {
        this.getfundPool();
      } else if (tab.props.name == 'djRebateList') {
        this.getReturnPremiumRecord();
      } else if (tab.props.name == 'DJAbnormalCallList') {
        this.init();
        this.query10.agentId = '';
        this.query10.companyId = '';
        this.getTime();
        this.getdxtErrRecord();
      } else if (tab.props.name == 'DJfreeze') {
        this.getfrozenRecord();
      } else if (tab.props.name == 'numberControl') {
        this.getopenControlList();
      } else if (tab.props.name == 'accountReview') {
        if (this.phone) {
          this.auditResultData = '';
          this.getauditResult();
        }
      } else if (tab.props.name == 'frequencyLimit') {
        this.getdeptParam();
      } else if (tab.props.name == 'appointment') {
        this.getShipmentList();
      }
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    init() {
      fetchAgent(localStorage.getItem('user')).then(res => {
        this.agents = res.data;
      });
      this.getfetchDefaultCompanies();
    },
    getfetchDefaultCompanies() {
      let data = {
        currentUserId: localStorage.getItem('user'),
        subAgentId: ''
      };
      fetchDefaultCompanies(data).then(res => {
        if (res?.code === 200) {
          this.companys = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    agentChange(agentId) {
      this.query3.agentId = agentId;
      this.query3.companyId = '';
      this.singlequery.agentId = agentId;
      this.singlequery.companyId = '';
      this.query10.agentId = agentId;
      this.query10.companyId = '';
      if (agentId) {
        let data = {
          subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
          agentId: agentId
        };
        fetchCompanyByAgentId(data).then(res => {
          this.companys = res.data;
        });
      }
    },
    companyChange(companyId) {
      this.query3.companyId = companyId;
      this.singlequery.companyId = companyId;
      this.query10.companyId = companyId;
      let data = {
        companyId: companyId,
        currentUserId: localStorage.getItem('user')
      };
      fetchDepartment(data).then(res => {
        this.departments = res.data;
      });
    },
    toDateTimeStr(date) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (m < 10) {
        m = '0' + m;
      }
      if (d < 10) {
        d = '0' + d;
      }
      return y + '-' + m + '-' + d;
    },
    //筛选时间
    getTime() {
      let startTime = new Date(new Date());
      let endTime = new Date();
      this.timeArr.push(startTime);
      this.timeArr.push(endTime);
    },
    dxtQuerys() {
      this.dxtDet = '';
      this.dosageVO = '';
      this.tableData3 = [];
      localStorage.setItem('userinfophone', this.phone);
      let data = {
        phone: this.phone
      };
      dxtQuery(data).then(res => {
        if (res?.code === 200) {
          this.dxtDet = res.data;
          this.dosageVO = JSON.parse(this.dxtDet.dosageVO);
          this.getstopOrOpenRecord2();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getstopOrOpenRecord2() {
      let data = {
        userId: localStorage.getItem('user'),
        phone: this.phone,
        pageIndex: 1,
        pageSize: 99,
      }
      this.loading = true;
      stopOrOpenRecord(data).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData3 = res.data.list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    batchQueryRecords() {
      this.loading = true;
      batchQueryRecord(this.query2).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData2 = res.data.list;
          this.pageTotal2 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getbatchQuery() {
      dxtbatchQuery(this.addForm1).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.addVisible1 = false;
          this.batchQueryRecords();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitUpload1() {
      if (this.$refs.upload1.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload1.submit();
        this.batchQueryRecords();
      } else {
        this.$message.error('请选择上传文件');
      }
    },
    //导入上传
    uploadSuccess1(success) {
      setTimeout(() => {
        this.$refs.upload1.clearFiles();
        this.addVisible1 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.batchQueryRecords();
      } else {
        this.$message.error(success.message);
      }
    },
    getbatchQueryRecord() {
      this.addVisible1 = true;
      this.addForm1.phones = '';
      this.addForm1.type = '2';
    },
    closeDialog1() {
      this.addVisible1 = false;
    },

    exportData() {
      this.loading = true;
      let data = {
        operateMsg: this.query3.operateMsg
      };
      downloadStopOrOpenRecord(data).then(res => {
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        let fileName = '迪加停复机' + '.xls';
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
        this.loading = false;
      });
    },
    getstopOrOpenRecord() {
      this.loading = true;
      stopOrOpenRecord(this.query3).then(res => {
        this.loading = false;

        if (res?.code === 200) {
          this.tableData3 = res.data.list;
          this.pageTotal3 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleAdd3() {
      this.addVisible3 = true;
    },
    getstopOrOpens3() {
      stopOrOpen(this.addForm3).then(res => {
        if (res?.code === 200) {
          this.addVisible3 = false;
          this.$message.success(res.data);
          setTimeout(() => {
            this.getstopOrOpenRecord();
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitUpload3() {
      if (this.$refs.upload3.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload3.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },

    //导入上传
    uploadSuccess3(success) {
      setTimeout(() => {
        this.$refs.upload3.clearFiles();
        this.addVisible3 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.getstopOrOpenRecord();
      } else {
        // this.open(success.message);
        this.$message.error(success.message);
      }
    },
    getdownloadStopOrOpenRecord(orderId) {
      this.$confirm('确定要下载该批次数据吗？', '提示', {
        type: 'warning'
      })
          .then(() => {
            let data = {
              orderId: orderId
            };
            downloadStopOrOpenRecord(data).then(res => {
              const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
              });
              let downloadElement = document.createElement('a');
              let href = window.URL.createObjectURL(blob);
              downloadElement.href = href;
              let fileName = '停复机记录' + orderId + '.xlsx';
              downloadElement.download = fileName;
              document.body.appendChild(downloadElement);
              downloadElement.click();
              document.body.removeChild(downloadElement);
              window.URL.revokeObjectURL(href);
            });
          })
          .catch(() => {
          });
    },
    getRecordVisible(row) {
      this.repeatedVisible = true;
      this.repeatedForm.record = row.record;
      this.repeatedForm.recover = row.recover;
      this.repeatedForm.id = row.id;
      this.repeatedForm.hours = row.hours;
      this.repeatedForm.updatedAt = row.updatedAt;
    },
    closeDialog3() {
      this.addVisible3 = false;
      this.addForm3.phones = '';
      this.addForm3.operateMsg = '';
      this.addForm3.type = 'OPEN';
      this.tab1 = 'input';
      this.repeatedVisible = false;
    },
    getRecordingRecover() {
      let data = {
        id: this.repeatedForm.id,
        record: this.repeatedForm.record,
        hours: this.repeatedForm.hours
      };
      dxtRecordingRecover(data).then(res => {
        if (res?.code === 200) {
          this.repeatedVisible = false;
          this.$message.success(res.data);
          this.getstopOrOpenRecord();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getactivateRecord() {
      this.loading = true;
      activateRecord(this.query4).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData4 = res.data.list;
          this.pageTotal4 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleAdd4() {
      this.addVisible4 = true;
    },
    getstopOrOpens4() {
      getactivate(this.addForm4).then(res => {
        if (res?.code === 200) {
          this.addVisible4 = false;
          this.$message.success(res.data);
          this.getactivateRecord();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitUpload4() {
      if (this.$refs.upload4.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload4.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },
    closeDialog4() {
      this.addVisible4 = false;
      this.addForm4.phones = '';
      this.addForm4.operateMsg = '';
      this.addForm4.type = 'OPEN';
      this.tab1 = 'input';
    },
    //导入上传
    uploadSuccess4(success) {
      setTimeout(() => {
        this.$refs.upload4.clearFiles();
        this.addVisible4 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.getactivateRecord();
      } else {
        // this.open(success.message);
        this.$message.error(success.message);
      }
    },
    getdownloadActivateRecord(uid) {
      this.$confirm('确定要下载该批次数据吗？', '提示', {
        type: 'warning'
      }).then(() => {
        let data = {
          uid: uid
        };
        downloadActivateRecord(data).then(res => {
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          });
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          let fileName = '限制返档记录' + uid + '.xlsx';
          downloadElement.download = fileName;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        });
      })
          .catch(() => {
          });
    },
    getcancelProtectionList() {
      this.loading = true;
      cancelProtectionList(this.query5).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData5 = res.data.list;
          this.pageTotal5 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleAdd5() {
      this.addVisible5 = true;
    },
    submitAdd() {
      cancelProtection(this.addForm5).then(res => {
        if (res?.code === 200) {
          this.addVisible5 = false;
          this.$message.success(res.data);
          this.getcancelProtectionList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitUpload5() {
      if (this.$refs.upload5.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload5.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },
    closeDialog5() {
      this.addVisible5 = false;
      this.addForm5.phones = '';
      this.addForm5.operateMsg = '';
      this.addForm5.remark = '';
      this.tab1 = 'input';
    },
    //导入上传
    uploadSuccess5(success) {
      setTimeout(() => {
        this.$refs.upload5.clearFiles();
        this.addVisible5 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.getcancelProtectionList();
      } else {
        // this.open(success.message);
        this.$message.error(success.message);
      }
    },
    getMaintenanceSet() {
      this.maintenanceVisible = true;
      this.getCancellations();
    },
    addDomain() {
      this.dxtPackageForm.menuList.push({
        value: ''
      });
    },
    removeDomain(item) {
      var index = this.dxtPackageForm.menuList.indexOf(item)
      if (index !== -1) {
        this.dxtPackageForm.menuList.splice(index, 1)
      }
    },
    showDxtPackage() {
      this.dxtPackageForm.prices = [];
      this.dxtPackageForm.menuList = [];
      this.getDxtPackages();
      this.dxtPackageVisible = true;

    },
    closeDxtPackageDialog() {
      this.dxtPackageVisible = false;
    },
    updateDxtPackages() {
      this.dxtPackageForm.menuList.forEach(i => {
        this.dxtPackageForm.prices.push(i.value)
      })
      let data = {
        prices: this.dxtPackageForm.prices.join(',')
      }
      updateDxtPackage(data).then(res => {
        if (res?.code === 200) {
          this.getcancelProtectionList();
          this.dxtPackageVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    getDxtPackages() {
      getDxtPackage().then(res => {
        if (res?.code === 200) {
          res.data.forEach(item => {
            this.dxtPackageForm.menuList.push({
              value: item
            });
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getCancellations() {
      getCancellation(localStorage.getItem('user')).then(res => {
        if (res?.code === 200) {
          this.maintenanceForm.enable = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closeMaintenanceDialog() {
      this.maintenanceVisible = false;
    },
    updateCancellation() {
      updateCancellation(this.maintenanceForm).then(res => {
        if (res?.code === 200) {
          this.maintenanceVisible = false;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    topUpRecord() {
      topUpRecord(this.singlequery).then(res => {
        if (res?.code === 200) {
          this.singletableData = res.data.list;
          this.singletotal = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    batchTopUpRecords() {
      batchTopUpRecord(this.batchquery).then(res => {
        if (res?.code === 200) {
          this.batchtableData = res.data.list;
          this.batchpageTotal = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitUpload7() {
      if (this.$refs.upload7.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload7.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },
    getReturnPremium(row) {
      this.$confirm('确定要返销该批次数据吗？', '提示', {
        type: 'warning'
      })
          .then(() => {
            let data = {
              userId: localStorage.getItem('user'),
              uid: row.uid,
              phone: row.phone
            };
            ReturnPremium(data).then(res => {
              if (res?.code === 200) {
                this.$message.success(res.message);
                this.topUpRecord();
              } else {
                this.topUpRecord();
                this.$message.error(res.message);
              }
            });
          })
          .catch(() => {
          });
    },
    gettopUpRecordDownload(uid) {
      this.$confirm('确定要下载该批次数据吗？', '提示', {
        type: 'warning'
      })
          .then(() => {
            let data = {
              uid: uid
            };
            topUpRecordDownload(data).then(res => {
              let link = document.createElement('a');
              link.style.display = 'none';
              link.href = res.data;
              document.body.appendChild(link);
              link.click();
            });
          })
          .catch(() => {
          });
    },
    //导入上传
    uploadSuccess7(success) {
      setTimeout(() => {
        this.$refs.upload7.clearFiles();
        this.addVisible7 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.batchTopUpRecords();
      } else {
        // this.open(success.message);
        this.$message.error(success.message);
      }
    },
    getaddVisible() {
      this.addVisible7 = true;
    },
    closeDialog7() {
      this.addVisible7 = false;
    },
    getAdd() {
      this.singleVisible = true;
    },

    closesingleDialog() {
      this.singleForm.amount = '';
      this.singleForm.phone = '';
      this.singleVisible = false;
    },
    AddtopUp() {
      let data = {
        phone: this.singleForm.phone,
        amount: this.singleForm.amount,
        userId: localStorage.getItem('user')
      };
      AddtopUp(data).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          setTimeout(() => {
            this.singleVisible = false;
            this.topUpRecord();
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getAPPAdd() {
      this.APPVisible = true;
      this.getdxtEnabled();
    },
    closeAPPDialog() {
      this.APPVisible = false;
    },

    getstopDxtApp() {
      let data = {
        bon: this.APPForm.bon,
        userId: localStorage.getItem('user')
      };
      stopDxtApp(data).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.APPVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getdxtEnabled() {
      dxtEnabled().then(res => {
        if (res?.code === 200) {
          this.APPForm.bon = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    singlehandlePageChange(val) {
      this.singlequery.pageIndex = val;
      this.topUpRecord();
    },
    singlehandleSizeChange(val) {
      this.singlequery.pageSize = val;
      this.singlequery.pageIndex = 1; // 重置到第一页
      this.topUpRecord();
    },
    batchhandlePageChange(val) {
      this.batchquery.pageIndex = val;
      this.batchTopUpRecords();
    },
    batchhandleSizeChange(val) {
      this.batchquery.pageSize = val;
      this.singlequery.pageIndex = 1; // 重置到第一页
      this.batchquery();
    },
    addCapital() {
      this.addCapitalNum = true;
    },
    closeCapitalNum() {
      this.addCapitalNum = false;
      this.capitalForm.amount = '';
    },
    getcapitalPoolAdd() {
      let data = {
        amount: this.capitalForm.amount,
        userId: localStorage.getItem('user')
      };
      fundPoolAdd(data).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.addCapitalNum = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getfundPool() {
      let data = {
        userId: localStorage.getItem('user')
      };
      fundPool(data).then(res => {
        if (res?.code === 200) {
          this.capitaltableData = res.data.selectorList;
          this.capitaltotal = Number(res.data.total.toFixed(2));
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getReturnPremiumRecord() {
      this.loading = true;
      ReturnPremiumRecord(this.query9).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData9 = res.data.list;
          this.pageTotal9 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getdxtErrRecord() {
      this.loading = true;
      this.tableData10 = [];
      // 日期
      if (this.timeArr === null) {
        // this.$message.error('时间不能为空');
        // return;
        this.query10.startTime = '';
        this.query10.endTime = '';
      } else {
        let startTime = this.toDateTimeStr(this.timeArr[0]);
        let endTime = this.toDateTimeStr(this.timeArr[1]);
        this.query10.startTime = startTime;
        this.query10.endTime = endTime;
      }
      dxtErrRecord(this.query10).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData10 = res.data.list;
          this.pageTotal10 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getfrozenRecord() {
      this.loading = true;
      frozenRecord(this.query11).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData11 = res.data.list;
          this.pageTotal11 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //导出
    handleExport(row) {
      let data = {
        uid: row.uid,
      };
      frozenRecordDownload(data).then(res => {
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        let date = new Date();
        let y = date.getFullYear(); //获取完整的年份(4位)
        let m = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
        let r = date.getDate(); //获取当前日(1-31)
        let fileName = '迪加自选套餐冻结.xlsx';
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },
    handleAdd11() {
      this.addVisible11 = true;
    },
    getFrozen() {
      frozen(this.addForm11).then(res => {
        if (res?.code === 200) {
          this.addVisible11 = false;
          this.$message.success(res.data);
          setTimeout(() => {
            this.getfrozenRecord();
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closeDialog11() {
      this.addVisible11 = false;
      this.addForm11.phones = '';
      this.addForm11.remark = '';
      this.addForm11.type = '1';
    },
    getAdd12() {
      openControl(this.addForm12).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.addVisible12 = false;
          this.getopenControlList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getopenControlList() {
      this.loading = true;
      openControlList(this.query12).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData12 = res.data.list;
          this.pageTotal12 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleAdd12() {
      this.addForm12.city = '';
      this.addForm12.phones = '';
      this.addVisible12 = true;
    },
    closeDialog12() {
      this.addForm12.city = '';
      this.addForm12.phones = '';
      this.addVisible12 = false;
      this.deleteForm12.phones = "";
      this.deleteVisible12 = false;
    },
    batchDel() {
      let str = '';
      for (let i = 0; i < this.multipleSelection.length; i++) {
        str += this.multipleSelection[i].id + ',';
      }
      if (str === '') {
        this.deleteForm12.phones = "";
        this.deleteVisible12 = true;
      } else {
        this.$confirm('确定要删除吗？', '提示', {
          type: 'warning'
        })
            .then(() => {
              let param = {
                ids: str,
                userId: localStorage.getItem('user')
              };
              openControlDelete(param).then(res => {
                if (res?.code === 200) {
                  this.$message.success('删除成功');
                  this.getopenControlList();
                } else {
                  this.$message.error(res.message);
                }
              });
            })
            .catch(() => {
            });
      }
      this.multipleSelection = [];
    },
    batchDel2() {
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      })
          .then(() => {
            let param = {
              phones: this.deleteForm12.phones,
              userId: localStorage.getItem('user')
            };
            openControlDelete(param).then(res => {
              if (res?.code === 200) {
                this.$message.success('删除成功');
                this.deleteForm12.phones = '';
                this.deleteVisible12 = false;
                this.getopenControlList();
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch(() => {
          });
    },
    separateDelete(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          ids: row.id,
          userId: localStorage.getItem('user'),
        };
        openControlDelete(param).then(res => {
          if (res?.code === 200) {
            this.$message.success('删除成功');
            this.getopenControlList();
          } else {
            this.$message.error(res.message);
          }
        });
      })
          .catch(() => {
          });
    },
    getauditResult() {
      this.dxtDet = '';
      let data = {
        phone: this.phone
      };
      this.loading = true;
      auditResult(data).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.auditResultData = res.data.content;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getdeptParam() {
      deptParam(this.query15).then(res => {
        if (res?.code === 200) {
          this.tableData15 = res.data.list;
          this.pageTotal15 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    getShipmentList() {
      ShipmentList(this.query16).then(res => {
        if (res?.code === 200) {
          this.tableData16 = res.data.list;
          this.pageTotal16 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getImport() {
      this.frequencyLimitVisible = true;
      this.deletefrequencyLimitDowm = true;
      this.frequencyLimitForm.callNum = '';
      this.frequencyLimitForm.phones = '';
    },

    getAddFrequencyLimit() {
      AddFrequencyLimit(this.frequencyLimitForm).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.frequencyLimitVisible = false;
          this.frequencyLimitForm.callNum = '';
          this.frequencyLimitForm.phones = '';
          this.getdeptParam();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closefrequencyLimitDialog() {
      this.frequencyLimitVisible = false;
      this.frequencyLimitForm.callNum = '';
      this.frequencyLimitForm.phones = '';
      this.deletefrequencyLimitDowm = false;
    },
    showBatchDeletefrequency() {
      this.frequencyLimitVisible = true;
      this.deletefrequencyLimitDowm = false;
    },
    batchDeletefrequencyLimit2() {
      this.$confirm('是否要删除此号码的拨打频次？', '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '不删除',
        closeOnClickModal: false
      })
          .then(() => {
            let data = {
              phones: this.frequencyLimitForm.phones,
            }
            deleteBatch(data).then(res => {
              if (res?.code === 200) {
                this.$message.success(res.data);
                this.frequencyLimitVisible = false;
                this.deletefrequencyLimitDowm = false;
                this.getdeptParam();
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch(() => {
          });
    },

    batchDeletefrequencyLimit(row) {
      this.$confirm('是否要删除此号码的拨打频次？', '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '不删除',
        closeOnClickModal: false
      })
          .then(() => {
            let data = {
              phones: row.phone,
            }
            deleteBatch(data).then(res => {
              if (res?.code === 200) {
                this.$message.success(res.data);
                this.getdeptParam();
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch(() => {
          });
    },

    copyUrl(item) {
      let cInput = document.createElement('input');
      cInput.value = item;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$message.success('复制成功');
      document.body.removeChild(cInput);
    },

    closeShipmentUploadDialog() {
      this.shipmentUpload = false;
    },
    submitUpload16() {
      if (this.$refs.upload16.uploadFiles[0]) {
        this.$refs.upload16.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },
    //导入上传
    uploadSuccess16(success) {
      setTimeout(() => {
        this.$refs.upload16.clearFiles();
        this.shipmentUpload = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.getShipmentList();
      } else {
        this.$message.error(success.message);
      }
    },
    getreviewInfo() {
      reviewInfo().then(res => {
        if (res?.code === 200) {
          let downloadElement = document.createElement('a');
          downloadElement.href = res.data;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(downloadElement.href);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getAddForm16Visible(row) {
      this.addForm16Visible = true;
      this.addForm16.phone = '';
      this.addForm16.address = '';
      this.addForm16.custName = row.custName;
    },

    getshipmentUpload() {
      this.shipmentForm.ids = '';
      this.shipmentForm.trackingNumber = '';
      this.shipmentForm.logisticsCompany = '';
      if (this.multipleSelection.length > 0) {
        let hasError = false;
        let errorMessage = '';
        for (const item of this.multipleSelection) {
          if (!hasError && item.auditStatus == false) {
            errorMessage = '审核未通过';
            hasError = true;
          }
          if (!hasError && (!item.address || !item.phone)) {
            errorMessage = '未填写收货信息';
            hasError = true;
          }
          if (!hasError && (item.logisticsCompany || item.trackingNumber)) {
            errorMessage = '已录入快递单号';
            hasError = true;
          }
          // 如果发现错误，立即跳出循环
          if (hasError) {
            break;
          }
          this.shipmentForm.ids += item.id + ',';
        }
        // 如果有错误，显示错误信息并清空ids
        if (hasError) {
          this.$message.error(errorMessage);
          this.shipmentForm.ids = '';
        }
        this.shipmentUpload2 = !hasError;
      } else {
        this.shipmentUpload = true;
      }
    },
    getshipmentUpload2() {
      this.shipmentUpload2 = false;
    },
    getImportShipmentInfo() {
      let data = {
        trackingNumber: this.shipmentForm.trackingNumber,
        ids: this.shipmentForm.ids,
        logisticsCompany: this.shipmentForm.logisticsCompany,
      };
      importShipmentInfo(data).then(res => {
        if (res?.code === 200) {
          this.shipmentUpload2 = false;
          this.shipmentForm.trackingNumber = '';
          this.shipmentForm.logisticsCompany = '';
          this.$message.success(res.data);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getLogisticsInfo(row) {
      this.logisticsInfoList2 = [];
      this.logisticsInfoList = [];
      const data = {
        trackingNumber: row.trackingNumber,
        logisticsCompany: row.logisticsCompany,
        phone: row.phone,
      };

      logisticsInfo(data).then(res => {
        if (res?.code === 200) {
          if (res.data && res.data.length > 0) {
            this.logisticsInfoVisible = true;
            const companyMap = {
              'SF': () => this.logisticsInfoList2 = res.data,
              'ST': () => this.logisticsInfoList = res.data,
            };
            const handler = companyMap[row.logisticsCompany];
            if (handler) {
              handler();
            } else {
              this.logisticsInfoList = res.data;
            }
          } else {
            this.$message.error('暂无物流信息');
          }
        } else {
          this.$message.error(res?.message || '获取物流信息失败');
        }
      }).catch(error => {
        this.$message.error('网络请求失败，请重试');
      });
    },
    getClearLogisticsInfo(row, type) {
      let info = '';
      if (type === 1) {
        info = ' 物流信息数据';
      } else {
        info = ' 收货地址';
      }
      this.$confirm('确定要清除号码: ' + row.phoneNum + info + '吗？', '提示', {
        type: 'warning'
      }).then(() => {
        const data = {
          id: row.id,
          type: type
        }
        clearLogisticsInfo(data).then(res => {
          if (res.code === 200) {
            this.getShipmentList();
            this.$message.success(res.data);
          } else {
            this.$message.error(res.message);
          }
        }).catch(error => {
          this.$message.error('网络请求失败，请重试');
        });
      })
          .catch(() => {
          });
    },
    // getMailing() {
    // 	let data = {
    // 		phone: this.addForm16.phone,
    // 		address: this.addForm16.address,
    // 		ids: this.selectedItems.join(),
    // 	};
    // 	mailing(data).then(res => {
    // 		if (res?.code === 200) {
    // 			this.addForm16Visible = false;
    // 			this.addForm16.phone = '';
    // 			this.addForm16.address = '';
    // 			this.$message.success(res.data);
    // 		} else {
    // 			this.$message.error(res.message);
    // 		}
    // 	});
    // },
    bulrInspectionAddress() {
      this.inspectionAddressBtn = true;
    },
    // getInspectionAddress() {
    // 	let data = {
    // 		address: this.addForm.address,
    // 	};
    // 	InspectionAddress(data).then(res => {
    // 		if (res?.code === 200) {
    // 			if (res.data) {
    // 				this.inspectionAddressBtn = false;
    // 				this.addForm.address = res.data;
    // 			} else {
    // 				this.$message.error('请输入正确地址');
    // 			}
    // 		} else {
    // 			this.$message.error(res.message);
    // 		}
    // 	});
    // },
    // 分页导航
    handlePageChange(val) {
      if (this.activeName == 'userInfo') {
        this.query1.pageIndex = val;
      } else if (this.activeName == 'userInfoBatch') {
        this.query2.pageIndex = val;
        this.batchQueryRecords();
      } else if (this.activeName == 'restartRecordList') {
        this.query3.pageIndex = val;
        this.getstopOrOpenRecord();
      } else if (this.activeName == 'activationList') {
        this.query4.pageIndex = val;
        this.getactivateRecord();
      } else if (this.activeName == 'NoShutdownMaintenanceNumber') {
        this.query5.pageIndex = val;
        this.getcancelProtectionList();
      } else if (this.activeName == 'djRecharge') {
        this.singlequery.pageIndex = val;
        this.topUpRecord();
      } else if (this.activeName == 'djBatchRecharge') {
        this.query7.pageIndex = val;
        this.batchTopUpRecords();
      } else if (this.activeName == 'djCapitalPool') {
        this.query8.pageIndex = val;
        this.getfundPool();
      } else if (this.activeName == 'djRebateList') {
        this.query9.pageIndex = val;
        this.getReturnPremiumRecord();
      } else if (this.activeName == 'DJAbnormalCallList') {
        this.query10.pageIndex = val;

        this.getdxtErrRecord();
      } else if (this.activeName == 'DJfreeze') {
        this.query11.pageIndex = val;
        this.getfrozenRecord();
      } else if (this.activeName == 'numberControl') {
        this.query12.pageIndex = val;
        this.getopenControlList();
      } else if (this.activeName == 'accountReview') {
        this.query13.pageIndex = val;
        if (this.phone) {
          this.auditResultData = '';
          this.getauditResult();
        }
      } else if (this.activeName == 'frequencyLimit') {
        this.query15.pageIndex = val;
        this.getdeptParam();
      } else if (this.activeName == 'appointment') {
        this.query16.pageIndex = val;
        this.getShipmentList();
      }
    },
    handleSizeChange(val) {
      if (this.activeName == 'userInfo') {
        this.query1.pageSize = val;
        this.query1.pageIndex = 1; // 重置到第一页
      } else if (this.activeName == 'userInfoBatch') {
        this.query2.pageSize = val;
        this.query2.pageIndex = 1; // 重置到第一页
        this.batchQueryRecords();
      } else if (this.activeName == 'restartRecordList') {
        this.query3.pageSize = val;
        this.query3.pageIndex = 1; // 重置到第一页
        this.getstopOrOpenRecord();
      } else if (this.activeName == 'activationList') {
        this.query4.pageSize = val;
        this.query4.pageIndex = 1; // 重置到第一页
        this.getactivateRecord();
      } else if (this.activeName == 'NoShutdownMaintenanceNumber') {
        this.query5.pageSize = val;
        this.query5.pageIndex = 1; // 重置到第一页
        this.getcancelProtectionList();
      } else if (this.activeName == 'djRecharge') {
        this.singlequery.pageSize = val;
        this.singlequery.pageIndex = 1; // 重置到第一页
        this.topUpRecord();
      } else if (this.activeName == 'djBatchRecharge') {
        this.query7.pageSize = val;
        this.query7.pageIndex = 1; // 重置到第一页
        this.batchTopUpRecords();
      } else if (this.activeName == 'djCapitalPool') {
        this.query8.pageSize = val;
        this.query8.pageIndex = 1; // 重置到第一页
        this.getfundPool();
      } else if (this.activeName == 'djRebateList') {
        this.query9.pageSize = val;
        this.query9.pageIndex = 1; // 重置到第一页
        this.getReturnPremiumRecord();
      } else if (this.activeName == 'DJAbnormalCallList') {
        this.query10.pageSize = val;
        this.query10.pageIndex = 1; // 重置到第一页
        this.getdxtErrRecord();
      } else if (this.activeName == 'DJfreeze') {
        this.query11.pageSize = val;
        this.query11.pageIndex = 1; // 重置到第一页
        this.getfrozenRecord();
      } else if (this.activeName == 'numberControl') {
        this.query12.pageSize = val;
        this.query12.pageIndex = 1; // 重置到第一页
        this.getopenControlList();
      } else if (this.activeName == 'accountReview') {
        this.query13.pageSize = val;
        this.query13.pageIndex = 1; // 重置到第一页
        if (this.phone) {
          this.auditResultData = '';
          this.getauditResult();
        }
      } else if (this.activeName == 'frequencyLimit') {
        this.query15.pageSize = val;
        this.query15.pageIndex = 1; // 重置到第一页
        this.getdeptParam();
      } else if (this.activeName == 'appointment') {
        this.query16.pageSize = val;
        this.query16.pageIndex = 1; // 重置到第一页
        this.getShipmentList();
      }
    },
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.recharge-box .el-radio__input {
  display: none;
}

.recharge-box .el-radio.is-bordered {
  padding: 8px 14px 0 5px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 30px;
}

.table-box {
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;

.user-info-box {
  width: 600px;
}

.user-info-tit {
  background: #fafafa;
  color: #000;
  font-weight: 600;
  text-align: center;
  line-height: 34px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.info-box {
  display: flex;
  flex-direction: row;
  line-height: 34px;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.info-name {
  background: #fafafa;
  border-right: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  width: 36%;
  padding-left: 10px;
  font-weight: 600;
}

.user-info-box .info-box .info {
  padding-left: 10px;
  color: #226003;
  width: 80%;
}

}


.down {
  border: 1px solid #dcdfe6;
  background: #4f7afd;
  color: #ffffff;
  transition: 0.1s;
  font-weight: 500;
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 4px;
  display: inline-block;
}

.region_list {
  display: flex;
  flex-direction: row;
  width: 30%;
}

.region_list_tit {
  font-size: 16px;
  font-weight: 600;
}

.region_list_info {
  font-size: 16px;
}

.region_box {
  width: 75%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 20px;
}

.grid-content {
  display: flex;
  align-items: center;
  height: 100px;
}

/deep/ .el-col-16 {
  flex: 0 0 59.9%;
}

.grid-cont-right {
  flex: 1;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #999;
}

.grid-num {
  font-size: 30px;
  font-weight: bold;
}

.grid-con-icon {
  font-size: 50px;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #fff;
}

.grid-con-1 .grid-con-icon {
  background: linear-gradient(#ffb199, #ff0844);
}

.new {
  color: #b5b4b4;
  font-size: 12px;
}

.grid-con-1 .grid-num {
  color: #4f7afd;
}

.grid-con-2 .grid-con-icon {
  background: linear-gradient(#48c6ef, #6f86d6);
}

.grid-con-2 .grid-num {
  color: #4f7afd;
}

.grid-con-3 .grid-con-icon {
  background: linear-gradient(#e5b2ca, #7028e4);
}

.grid-con-3 .grid-num {
  color: #4f7afd;
}

.grid-con-4 .grid-con-icon {
  background: linear-gradient(#00c6fb, #005bea);
}

.grid-con-4 .grid-num {
  color: #4f7afd;
}

.grid-con-5 .grid-con-icon {
  background: linear-gradient(#89f7fe, #66a6ff);
}

.grid-con-5 .grid-num {
  color: #4f7afd;
}

.status_color2 {
  color: #fff;
  background-color: #ff0000;
  border-radius: 3px;
  display: inline-block;
  width: 60px;
  height: 26px;
  padding: 0 6px;
  text-align: center;
  line-height: 26px;
  font-size: 12px;
}

.bgred {
  background-color: #ff0000;
}

.bggreen {
  background-color: #67c23a;
}

.table-box2 {
  width: 1400px;
  border: 1px solid #ebeef5;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;

.user-info-box {
  /* border: 1px solid #ebeef5; */

  width: 600px;
}

.user-info-tit {
  background: #fafafa;
  color: #000;
  font-weight: 600;
  text-align: center;
  line-height: 34px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.info-box {
  display: flex;
  flex-direction: row;
  line-height: 34px;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.info-name {
  background: #fafafa;
  border-right: 1px solid #ebeef5;
  width: 30%;
  padding-left: 10px;
  font-weight: 600;
}

.user-info-box .info-box .info {
  padding-left: 10px;
  color: #226003;
  width: 80%;
}

}
</style>